import axios from 'axios';
import {
    removeErrors,
    validate,
    makeFormData,
    serialize,
    addFiles,
    uploadFile,
} from './form';

export default class CareerForm {
    private selector: HTMLFormElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        if (this.selector) {
            this.init();
        }
    }

    private init(): void {
        const button: HTMLElement = this.selector.querySelector('[data-form-file-button]');
        if (button) {
            uploadFile(button);
        }

        removeErrors(this.selector);

        this.selector.addEventListener('submit', this.submitForm.bind(this));
    }

    private submitForm(e: Event): void {
        e.preventDefault();

        const form = e.target as HTMLFormElement;
        const parent: HTMLElement = form.closest('[data-text-form]');
        const success: HTMLElement = parent.querySelector('[data-text-form-success]');
        const content: HTMLElement = parent.querySelector('[data-text-form-content]');
        const button: HTMLElement = form.querySelector('[data-form-button]');
        const valid = validate(form);

        if (valid) {
            button.classList.add('button--disabled');

            let data: FormData = makeFormData(serialize(form));
            data = addFiles(form, data);

            axios({
                method: 'POST',
                url: form.action,
                data,
            }).then(() => {
                content.classList.remove('text-form__container--show');
                success.classList.add('text-form__success--show');
            });
        }
    }
}
